/* Обёртка тела формы режима (use-held-mode.ts): видимое тело участвует в раскладке экрана как раньше (display: contents),
   новое собирается скрытым; пока режим переключается, прежнее неактивно (inert) — без приглушения, как стоит у шаблона.
   Встав на место прежнего, тело входит появлением, как renderBody(true) шаблона. */
import { useLayoutEffect, useRef, type ReactNode } from 'react';
import { ModeReplacedContext, type HeldBody } from './use-held-mode';
import { pop } from '../../ui/motion';

export function HeldModeBody<T extends { id: number }, S>({ body, lock, children }: { body: HeldBody<T, S>; lock: boolean; children: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  const wasVisible = useRef(body.visible);
  useLayoutEffect(() => {
    if (body.visible && !wasVisible.current) pop(ref.current?.querySelector('form'));
    wasVisible.current = body.visible;
  }, [body.visible]);
  return (
    <div
      ref={ref}
      className="studio-mode-body"
      style={body.visible ? { display: 'contents' } : undefined}
      hidden={!body.visible}
      inert={!body.visible || lock}
    >
      <ModeReplacedContext.Provider value={body.replaced}>{children}</ModeReplacedContext.Provider>
    </div>
  );
}
